<template>
  <PopupContainer
    @close="closePopup"
    @blur="closePopup"
    @swipe="(direction) => swipePost(direction)"
    @scroll="(scrollPos) => loadCustomersMediaOnScroll(scrollPos)"
  >
    <template #content="contentWrapper">
      <div class="frisbuy-popup-inner">
        <div class="frisbuy-popup-content">
          <ArrowButton
            v-if="showLeftArrow"
            customClass="frisbuy-popup-content__button"
            direction="left"
            @click="selectPrevPost"
          />

          <div class="frisbuy-popup-content__image">
            <img
              :src="DomainSubstitute(selectedImage)"
              @error="errorImageHandler"
            />

            <span
              v-if="currentMedia.videoUrl && !isVideoPlaying"
              class="frisbuy-popup-content__play-icon"
              @click="playVideo"
            >
              <svg width="29" height="31" viewBox="0 0 29 31" fill="none">
                <g filter="url(#filter0_d_4369_3101)">
                  <path
                    d="M21.4186 12.7112C23.5271 13.9506 23.5271 17.0494 21.4186 18.2888L10.7442 24.5638C8.63566 25.8032 6 24.2539 6 21.7749L6 9.22509C6 6.74611 8.63566 5.19675 10.7442 6.43624L21.4186 12.7112Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_4369_3101"
                    x="-3"
                    y="-2"
                    width="35"
                    height="35"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_4369_3101"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_4369_3101"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </span>

            <video
              v-if="currentMedia.videoUrl"
              v-show="isVideoPlaying"
              :src="currentMedia.videoUrl"
              controls
              loop="true"
              controlsList="nodownload"
              playsinline
              ref="videoElement"
              @pause="videoElement && pauseVideo"
            ></video>
          </div>

          <div class="frisbuy-popup-content__info">
            <CustomerReview
              :customerName="
                post.instagramPost.authorUser.fio ||
                `@${post.instagramPost.authorUser.username}`
              "
              :reviewDate="props.reviewDate"
              :reviewTime="props.reviewTime"
              :reviewMarketplace="props.reviewMarketplace"
              :rating="post.frisbuyPost.rating"
              :negativeComment="post.frisbuyPost.negativeComment"
              :positiveComment="post.frisbuyPost.positiveComment"
              :text="post.frisbuyPost.text"
              :mediaList="props.post.media"
              :sectionsMarginTop="['0', '20px', '30px']"
              :mediaSectionConfig="{
                margin: '30px 0 0 0',
                order: 2,

                wrap: 'wrap',
                mediaWidth: reviewMediaListItemsWidth,
              }"
              :textSectionConfig="{
                margin: '20px 0 0 0',
                order: 1,
              }"
              @selectMedia="(media) => selectMedia(media)"
            />
          </div>

          <ArrowButton
            v-if="showRightArrow"
            customClass="frisbuy-popup-content__button"
            direction="right"
            @click="selectNextPost"
          />
        </div>

        <div
          v-if="allCustomersMediaList.length"
          class="frisbuy-popup-customers-reviews"
        >
          <h3>Другие фото из отзывов</h3>

          <div class="frisbuy-popup-media-list">
            <MediaList
              :mediaList="props.allCustomersMediaList"
              :mediaWidth="allCustomersMediaListItemsWidth"
              wrap="wrap"
              @selectMedia="
                (media) => {
                  selectPost(media.postId, media);

                  // NOTE: `nextTick` only for fix Safari
                  nextTick(() => {
                    contentWrapper.scrollToTop();
                  });
                }
              "
            />
          </div>
        </div>
      </div>
    </template>
  </PopupContainer>
</template>

<style scoped lang="scss">
@import "@/widgets/MarketplaceReviews/mixins.scss";

.frisbuy-popup-inner {
  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  padding: 30px;

  .frisbuy-popup-content,
  .frisbuy-popup-customers-reviews {
    padding: 0 50px;
  }

  .frisbuy-popup-content {
    display: grid;
    position: relative;
    grid-template-columns: 2fr 1fr;
    gap: 30px;

    .frisbuy-popup-content__button {
      top: 27.95436dvw; // NOTE: 50% of frisbuy-popup-content__image height
    }

    .frisbuy-popup-content__image,
    .frisbuy-popup-content__info {
      overflow-x: hidden;
    }

    .frisbuy-popup-content__image {
      position: relative;

      width: 100%;
      aspect-ratio: 1 / 1;

      img,
      video {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      video {
        position: absolute;
        inset: 0;
      }

      .frisbuy-popup-content__play-icon {
        position: absolute;
        inset: 50%;
        transform: translate(-50%, -50%);

        width: 30%;
        height: 30%;

        z-index: 1;

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    .frisbuy-popup-content__info {
      overflow-y: auto;
    }
  }

  .frisbuy-popup-customers-reviews {
    margin-top: 30px;

    h3 {
      font-family: Inter, sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 22px;
    }

    .frisbuy-popup-media-list {
      margin-top: 10px;
    }
  }
}

@media (max-width: 1024px) {
  .frisbuy-popup-inner {
    padding: 30px 16px;

    .frisbuy-popup-content,
    .frisbuy-popup-customers-reviews {
      padding: 0;
    }

    .frisbuy-popup-content {
      grid-template-columns: 1fr 1fr;

      .frisbuy-popup-content__button {
        display: none;
      }
    }
  }
}

@media (max-width: $size-s) {
  .frisbuy-popup-inner {
    .frisbuy-popup-content {
      grid-template-columns: 1fr;

      padding-bottom: 30px;
      border-bottom: 1px solid #dcdfe6;
    }
  }
}
</style>

<script setup lang="ts">
// Modules
import {
  defineProps,
  defineEmits,
  ref,
  watch,
  withDefaults,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
} from "vue";
// Components
import PopupContainer from "../PopupContainer/PopupContainer.vue";
import CustomerReview from "../CustomerReview.vue";
import MediaList from "../MediaList.vue";
import ArrowButton from "../ArrowButton.vue";
// Services
import { MediaCatcher } from "@/common/services/ErrorHandler/ErrorCatcher";
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Consts
import widgetTypes from "@/common/consts/widgetTypes";
// Types
import { IPostMedia } from "@/gallery/interfaces";
import { TSwipe } from "../../globals";
import { imageWithPostId, IMarketplaceReviewsPost } from "../../interfaces";

const props = withDefaults(
  defineProps<{
    post: IMarketplaceReviewsPost;
    selectedMediaIndex: number;
    showLeftArrow: boolean;
    showRightArrow: boolean;

    settings: { [key: string]: any };

    allCustomersMediaList?: Array<imageWithPostId>;

    reviewDate: string;
    reviewTime: string;
    reviewMarketplace?: string;
  }>(),
  {
    showLeftArrow: true,
    showRightArrow: true,
    allCustomersMediaList: () => [],
  }
);

const emit = defineEmits([
  "selectPrevPost",
  "selectNextPost",
  "close",
  "selectPost",
  "requestToLoadCustomersMedia",
  "sendAnaliticEvent",
]);

const currentMediaIndex = ref<number>(props.selectedMediaIndex);

const currentMedia = computed<IPostMedia>(() => {
  return props.post.media[currentMediaIndex.value];
});

const errorImagePlug = "https://www.frisbuy.ru/images/empty_media.png";
const selectedImage = ref<string | undefined>(
  currentMedia.value.imageHighResolutionUrl
);

watch(
  () => [props.post, props.selectedMediaIndex],
  () => {
    // TODO: try to rewrite next line as v-model
    currentMediaIndex.value = props.selectedMediaIndex;

    selectedImage.value =
      props.post.media[props.selectedMediaIndex].imageHighResolutionUrl;
  }
);

function selectPrevPost() {
  emit("selectPrevPost");
}

function selectNextPost() {
  emit("selectNextPost");
}

function swipePost(direction: TSwipe) {
  if (direction === "left") {
    selectNextPost();
  }

  if (direction === "right") {
    selectPrevPost();
  }
}

function closePopup() {
  emit("close");
}

function selectMedia(media: imageWithPostId) {
  if (isVideoPlaying.value) {
    stopVideo();
  }

  const postId =
    props.post.instagramPost?.frisbuyId || props.post.providerPost?.frisbuyId;
  selectPost(postId, media);
}

const videoElement = ref<HTMLVideoElement | null>(null);
const isVideoPlaying = ref(false);
function playVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  emit("sendAnaliticEvent", "PlayVideo", {
    provPostId: props.post.instagramPost?.frisbuyId ?? props.post.providerPost.frisbuyId,
    fbProduct: props.post.frisbuyPost.id,
    igCode: props.post.instagramPost.shortcode,
  });


  isVideoPlaying.value = true;

  videoElement.value.play();
}

function pauseVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  isVideoPlaying.value = false;

  videoElement.value.pause();
}

function stopVideo() {
  if (!videoElement.value) {
    console.warn("videoElement is 'null'");
    return;
  }

  isVideoPlaying.value = false;

  videoElement.value.pause();
  videoElement.value.currentTime = 0;
}

// Customers photo
function selectPost(postId: number, media?: imageWithPostId) {
  if (isVideoPlaying.value) {
    stopVideo();
  }

  emit("selectPost", postId, media);
}

// Customers photo loading on scroll
function loadCustomersMediaOnScroll(scrollPos: {
  top: number;
  bottom: number;
}) {
  if (scrollPos.bottom <= 0) {
    emit("requestToLoadCustomersMedia");
  }
}

// MediaList items size
onMounted(() => {
  changeAllCustomersMediaListItemsWidth();
  window.addEventListener("resize", changeAllCustomersMediaListItemsWidth);

  changeReviewMediaListItemsWidth();
  window.addEventListener("resize", changeReviewMediaListItemsWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", changeAllCustomersMediaListItemsWidth);
  window.removeEventListener("resize", changeReviewMediaListItemsWidth);
});

const reviewMediaListItemsWidth = ref<string>();
function changeReviewMediaListItemsWidth() {
  let itemsWidth = "65px";

  if (document.body.clientWidth <= 1024) {
    itemsWidth = "87px";
  }

  reviewMediaListItemsWidth.value = itemsWidth;
}

let allCustomersMediaListItemsWidth = ref<string>();
function changeAllCustomersMediaListItemsWidth() {
  let gap = "5px";
  let itemsInRow = 6;

  if (document.body.clientWidth <= 767) {
    itemsInRow = 2;
  } else if (document.body.clientWidth <= 1024) {
    itemsInRow = 3;
  } else {
    itemsInRow = 6;
  }

  allCustomersMediaListItemsWidth.value = `calc(1 / ${itemsInRow} * 100% - calc(${gap} * ${
    (itemsInRow - 1) / itemsInRow
  })`;
}

function errorImageHandler(e: Event) {
  MediaCatcher(e, 2, widgetTypes.STORY);
}
</script>
